import { makeStyles } from "@material-ui/core";

export const useConstructionPlanningTableStyles = makeStyles((theme) => ({
  grid: {
    backgroundColor: "white",
    borderRadius: "0px",
    border: "none",
    fontSize: 12,
    height: "100%",
  },
  gridCell: {
    // fontSize: "0.8em",
    // padding: 0,
    // borderLeft: "1px solid #eeeeee",
    border: "none",
    // textAlign: "center",
    background: "rgb(241, 242, 242)",
    borderBottom: "1px solid #dddede",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  whiteBackground: {
    background: "white!important",
  },
  gridCellCentered: {
    textAlign: "center",
  },
  gridCellValueFilled: {
    widht: "100%",
    height: "100%",
  },
  gridCellCompleted: {
    color: "grey",
    textDecoration: "line-through",
  },
  gridCellHighlighted: {
    backgroundColor: theme.palette.primary.light,
    color: "white",
  },
  header: {
    lineHeight: 2,
    // border: 0,
    // fontSize: "0.8em",
    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    "& span": {
      height: "100%",
    },
  },
  headerFilterable: {
    lineHeight: 2,
    "& span": {
      height: "auto!important",
    },
  },
  gridToolbar: {
    backgroundColor: "#eeeeee",
  },
  textFieldContainer: {
    padding: 8,
    height: "100%",
    backgroundColor: "#eeeeee",
    borderRight: "2px solid white",
    color: "grey",
  },
  checkboxFieldContainer: {
    padding: 8,
    paddingLeft: 16,
    height: "100%",
    backgroundColor: "#eeeeee",
    borderRight: "2px solid white",
    color: "grey",
  },
}));
